import * as React from 'react';
import createIconComponent from '../createIconComponent.js';

var l = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", fill: "none", viewBox: "0 0 32 32" },
    React.createElement("path", { fill: "#1010101", fillRule: "evenodd", d: "M21.375 6.25h-9.5v5h-4v14.5h17.5v-14.5h-4zm-1.5 5v-3.5h-6.5v3.5zm-10.5 13v-11.5h14.5v11.5z", clipRule: "evenodd" })));
var Cart = createIconComponent({ l: l });

export { Cart as default };
//# sourceMappingURL=Cart.js.map
